import { useThemeStore } from "@stores/theme.store";
import moment from "moment";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const StudentTahfidzDetailPage = () => {
  const { state } = useLocation();
  const { setFooter, setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setFooter(false);
    setHeader({
      type: "small",
      title: "Detail Tahfidz Santri",
      buttonBack: true,
      avatar: true,
    });
    setAppBar({ title: "Detail Tahfidz Santri", leading: "back" });
  }, [setFooter, setHeader, setAppBar]);

  return (
    <div className="card card-style">
      <div className="content d-flex flex-column mb-0">
        <div className="color-highlight">Tanggal Tahfidz</div>
        <div className="color-theme mb-3">
          {moment(state.tanggal ?? Date.now()).format(
            "dddd, DD MMMM YYYY | HH:mm"
          )}
        </div>
        <div className="color-highlight">Tambahan</div>
        <div className="color-theme mb-3">{state.tambahan ?? "-"} Halaman</div>
        <div className="color-highlight">Murojaah</div>
        <div className="color-theme mb-3">{state.murojaah ?? "-"}</div>
        <div className="color-highlight">Keterangan</div>
        <div className="color-theme mb-3">{state.catatan ?? "-"}</div>
      </div>
    </div>
  );
};
